import { Routes } from '@angular/router';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignInGuard } from './guards/sign-in.guard';

export const routes: Routes = [
  {
    path: 'signup',
    component: SignUpComponent,
    canActivate: [SignInGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.routes').then(m => m.adminRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('./layout/layout.routes').then(m => m.layoutRoutes),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./layout/common/PageNotFound/page-not-found/page-not-found.component')
        .then(m => m.PageNotFoundComponent),
  },
];
